let previousScreenWidth = 0;
const initCollapsible = (collapsible) => {
    updateCollapsibleMaxHeight(collapsible);
    const toggle = collapsible.querySelector('.js-collapsible-toggle');
    if (!toggle) {
        return;
    }
    toggle.addEventListener('click', () => collapsible.classList.toggle('open'));
};
const updateCollapsibleMaxHeight = (collapsible) => {
    const collapsibleContentContainer = collapsible.querySelector('.js-collapsible-content-container');
    const collapsibleContent = collapsible.querySelector('.js-collapsible-content');
    if (!collapsibleContentContainer || !collapsibleContent) {
        return;
    }
    const wasOpen = collapsible.classList.contains('open');
    collapsibleContentContainer.classList.toggle('disable-transition', true);
    collapsible.classList.toggle('open', true);
    collapsible.style.setProperty('--container-height', collapsibleContent.clientHeight.toString() + 'px');
    collapsible.classList.toggle('open', wasOpen);
    collapsibleContentContainer.classList.toggle('disable-transition', false);
};
export const initCollapsibles = () => {
    const collapsibleElements = document.querySelectorAll('.js-collapsible');
    collapsibleElements.forEach((collapsible) => initCollapsible(collapsible));
    window.addEventListener('resize', () => {
        if (previousScreenWidth === window.screen.width) {
            return;
        }
        previousScreenWidth = window.screen.width;
        collapsibleElements.forEach((collapsible) => updateCollapsibleMaxHeight(collapsible));
    });
    window.addEventListener('pageChange', () => {
        collapsibleElements.forEach((collapsible) => updateCollapsibleMaxHeight(collapsible));
    });
};
